import { ReviewsRoute } from "@/modules/reviews/routes/reviews.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/reviews/")({
	component: ReviewsRoute,
});
